import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Portal from 'src/layout/Portal/Portal';
import moment from 'moment';
import { Grid } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import useEventListener from 'src/hooks/useEventListener';
import { TModalFullScreen, TModalSize } from 'src/type/modal-type';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import { BsXCircleFill } from 'react-icons/bs';

export default function ModalDetail({ isOpen, exit, data, name, t }) {
	const ccyFormat = (num) => {
		return `${typeof num === 'number' ? num?.toFixed(2) : '0.00'}`;
	};

	const convertDate = (data) => {
		const convert = moment(data).format('DD/MM/YYYY - HH:mm:ss');
		return convert;
	};

	return (
		<div>
			<Portal>
				<AnimatePresence mode='wait'>
					{isOpen && (
						<>
							<motion.div
								initial={{ scale: 0 }}
								animate={{ rotate: 0, scale: 1 }}
								transition={{
									type: 'spring',
									stiffness: 260,
									damping: 20,
								}}
								key='modal'
								className='modal show'
								style={{ display: 'block' }}
								tabIndex={-1}
								aria-hidden='true'>
								<div
									className='modal_detail
										modal-dialog-scrollable
										modal-dialog-centered'>
									<div className='modal-content'>
										<div className='div_edit_bar'>
											<div className='fw-bold h5'>{name}</div>
											<div className='div_exit' onClick={() => exit()}>
												<BsXCircleFill
													style={{ width: '15px', height: 'auto' }}
												/>
											</div>
										</div>
										<hr style={{ margin: '0px 0px 1rem 0px' }} />
										<div className='div_detail'>
											<div className='div_detail_sec'>
												{name === 'Dowline Self Detail' ? (
													<Grid container spacing={0}>
														<Grid item xs={12} sm={12} lg={12}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_name')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{data?.payment_provider?.name}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_create_at')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{convertDate(
																		data?.payment_provider
																			?.createdAt,
																	)}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_update_at')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{convertDate(
																		data?.payment_provider
																			?.updatedAt,
																	)}
																</div>
															</div>
														</Grid>

														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	Max deposit
																</div>
																<div className='div_detail_title_title_sec'>
																	<NumericFormat
																		value={ccyFormat(
																			data?.payment_provider
																				?.max_deposit,
																		)}
																		thousandSeparator
																		displayType={'text'}
																	/>
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	Min deposit
																</div>
																<div className='div_detail_title_title_sec'>
																	<NumericFormat
																		value={ccyFormat(
																			data?.payment_provider
																				?.min_deposit,
																		)}
																		thousandSeparator
																		displayType={'text'}
																	/>
																</div>
															</div>
														</Grid>

														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	Max Withdraw
																</div>
																<div className='div_detail_title_title_sec'>
																	<NumericFormat
																		value={ccyFormat(
																			data?.payment_provider
																				?.max_withdraw,
																		)}
																		thousandSeparator
																		displayType={'text'}
																	/>
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	Min Withdraw
																</div>
																<div className='div_detail_title_title_sec'>
																	<NumericFormat
																		value={ccyFormat(
																			data?.payment_provider
																				?.min_withdraw,
																		)}
																		thousandSeparator
																		displayType={'text'}
																	/>
																</div>
															</div>
														</Grid>
													</Grid>
												) : (
													<Grid container spacing={0}>
														<Grid item xs={12} sm={12} lg={12}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_status')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{data?.status}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_create_at')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{convertDate(data?.createdAt)}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_update_at')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{convertDate(data?.updatedAt)}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_transaction_time')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{convertDate(
																		data?.transaction_time,
																	)}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_amount')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{ccyFormat(data?.amount)}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_downline')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{data?.downline}
																</div>
															</div>
														</Grid>

														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_downline_amount')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{ccyFormat(
																		data?.downline_amount,
																	)}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_downline_fee')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{ccyFormat(data?.downline_fee)}
																</div>
															</div>
														</Grid>

														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_fee')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{ccyFormat(data?.fee)}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_upline_amount')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{ccyFormat(data?.upline_amount)}
																</div>
															</div>
														</Grid>

														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	{t('txt_user_agent')}
																</div>
																<div className='div_detail_title_title_sec'>
																	{data?.user_agent}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	Ref id
																</div>
																<div className='div_detail_title_title_sec'>
																	{data?.ref_id}
																</div>
															</div>
														</Grid>
														<Grid item xs={12} sm={12} lg={6}>
															<div className='div_detail_title_sec1'>
																<div className='div_detail_title_title'>
																	Prefix
																</div>
																<div className='div_detail_title_title_sec'>
																	{data?.api_prefix}
																</div>
															</div>
														</Grid>
													</Grid>
												)}
											</div>
										</div>
									</div>
								</div>
							</motion.div>
							<div className='modal-backdrop show'></div>
						</>
					)}
				</AnimatePresence>
			</Portal>
		</div>
	);
}
